import React, { FC } from 'react'
import { ResetWrapper } from './integrationsSelectResetSearch.styles'
import ThemeButton from 'ui/components/buttons/primary/ThemeButton'

interface Props {
  resetData: () => void
  disabled?: boolean
}

const IntegrationsSelectResetSearch: FC<Props> = ({ resetData, disabled }) => (
  <ResetWrapper className="reset-wrapper">
    <ThemeButton
      themevariant="hollow"
      onClick={() => resetData()}
      disabled={disabled}
      className="reset-button"
      disableRipple
      disableFocusRipple
      disableTouchRipple
    >
      Reset filter
    </ThemeButton>
  </ResetWrapper>
)

export default IntegrationsSelectResetSearch
